import { type FC } from 'react';

import bgPurple from '/img/shop/v2/bg-purple.svg';

// Figma "Bg purple": purple glow with a star pattern fading into the page
const Background: FC = () => (
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
    <img
      src={bgPurple}
      alt=""
      className="absolute top-0 left-0 w-full aspect-[428/926]"
    />
  </div>
);

export { Background };
